(function () {
	const header = () => {
		const megaMenuLinks = document.querySelectorAll(".list-menu--megamenu");
		megaMenuLinks.forEach((link) => {
			link.addEventListener("mouseenter", () => {
				link.classList.add("list-menu--megamenu-visible");
			});

			link.addEventListener("mouseleave", () => {
				setTimeout(() => {
					link.classList.remove("list-menu--megamenu-visible");
				}, 300);
			});
		});


		// NEW MEGA MENU
		const megaMenuBtns = document.querySelectorAll(".header__main-link[data-open-mega-menu]");
		const megaMenus = document.querySelectorAll(".header__main-link[data-open-mega-menu] .mega-menu-new");
		const megaMenuViewAllBtn = document.querySelector('.mega-menu-new__view-all');

		megaMenuBtns.forEach((link) => {
			link.addEventListener("click", (e) => {
				e.stopImmediatePropagation();
				let megaMenu = link.querySelector('.mega-menu-new');

				if(megaMenu){
					link.classList.add("list-menu--megamenu-visible");
					
					megaMenus.forEach((menu)=>{
						menu.classList.remove('open');
					})

					megaMenu.classList.add('open');
				}
			});
		});


		megaMenus.forEach((megaMenu)=>{
			let closeBtn = megaMenu.querySelector('.mega-menu-new__close-btn');

			closeBtn.addEventListener('click',(e)=>{
				e.stopImmediatePropagation();

				megaMenus.forEach((menu)=>{
					menu.classList.remove('open');
				})
			})
		})

		megaMenuViewAllBtn?.addEventListener('click',()=>{
			let originalBtn = document.querySelector('.header__shop-button');

			megaMenus.forEach((menu)=>{
				menu.classList.remove('open');
			})
			originalBtn?.click();
		})


		document.addEventListener("click", function (event) {
			if(!event.target.closest('.mega-menu-new')){
				megaMenus.forEach((menu)=>{
					menu.classList.remove('open');
				})
			}
		});
		
	};

	document.addEventListener("shopify:section:load", header);

	header();
})();